import { ErrorMessage } from "formik";
import React from "react";

export default function ErrorComponent(props: any) {
  const { name } = props;
  return <ErrorMessage name={name} render={(msg) => <div className="error  py-2">{msg}</div>} />;
}
